import http from "@/utils/http";

export default {
    myNetOrderList: data => {
        return http({url:'/api/agent/v1/order/getMyOrderPc',data}).then(r => r);
    },
    detail: data => {
        return http({url:'/api/agent/v1/order/getOrderDetail',data}).then(r => r);
    }
}